import { useLocation, useNavigate } from "react-router-dom-v5-compat";

import { asLocation } from "seneca-common/utils/routing";
import { logSignUpEventByAccountType } from "seneca-common/utils/senecaAnalytics/events/signUp";

import { getRedirectAuthenticatedUserToLocation } from "features/sign-up/global-sign-up-modal/links";
import { userAccountType } from "features/user/consts";

export type Props = {
  accountType?: string;
  linkToNextPage?: string;
  isSSO?: boolean;
  search?: string;
};

export default function useOnSignUpSuccess({
  linkToNextPage,
  accountType,
  isSSO = false,
  search = ""
}: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    const redirectToCustomPageLink =
      getRedirectAuthenticatedUserToLocation(location);

    if (
      accountType &&
      accountType === userAccountType.schoolparent &&
      redirectToCustomPageLink &&
      !isSSO
    ) {
      logSignUpEventByAccountType(accountType);
      const nextLocation = asLocation(redirectToCustomPageLink);
      navigate(nextLocation?.pathname + search, {
        replace: true,
        state: nextLocation?.state
      });
    } else {
      navigate(
        { pathname: linkToNextPage, search },
        {
          replace: true,
          state: {
            ...location.state,
            internalRedirect: true
          }
        }
      );
    }
  };
}
